module.exports = __webpack_public_path__ + "static/media/right-arrow-blue.a16da7b6.svg";